import { createSlice } from "@reduxjs/toolkit";

const chatSlice = createSlice({
  name: "chat",
  initialState: {
    allChatData: JSON.parse(localStorage.getItem("chatData")) || [], // Persist initial state from localStorage
  },
  reducers: {
    addNewChat: (state, action) => {
      state.allChatData.push(action.payload); // Add new chat message
      localStorage.setItem("chatData", JSON.stringify(state.allChatData)); // Save to localStorage
    },
    updateChatAnswer: (state, action) => {
      const { index, answer } = action.payload;
      state.allChatData[index].ans = answer;
      state.allChatData[index].loading = false;
      localStorage.setItem("chatData", JSON.stringify(state.allChatData)); // Update localStorage
    },
    setLoading: (state, action) => {
      const { index, loading } = action.payload;
      state.allChatData[index].loading = loading;
    },
    clearChat: (state) => {
      state.allChatData = [];
      localStorage.removeItem("chatData"); // Clear chat data in localStorage
    },
  },
});

export const { addNewChat, updateChatAnswer, setLoading, clearChat } =
  chatSlice.actions; // Export actions
export default chatSlice.reducer;
